import { render, staticRenderFns } from "./v_Terms_CookiePolicy.vue?vue&type=template&id=1638aea9&scoped=true&"
import script from "./v_Terms_CookiePolicy.vue?vue&type=script&lang=js&"
export * from "./v_Terms_CookiePolicy.vue?vue&type=script&lang=js&"
import style0 from "./v_Terms_CookiePolicy.vue?vue&type=style&index=0&id=1638aea9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1638aea9",
  null
  
)

export default component.exports